<template>
    <BasePanel 
        headline="lang_ERP_PRICELISTS_CAPTION_PRICELISTS_ROWS"
        >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items-per-page="itemsPerPage"
                :items="item.rows"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

<!-- alvqa="publishing-works-list-row-undefined-read-only-panel-35-society-shares-list-row-12818690-text-name" -->
                <template v-slot:[`item.distributorName`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:text>{{ item.distributorName }}</template>
                        <template v-slot:content>
                            <div class="ellipsis" :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-distributor-name'">
                                {{ item.distributorName }}
                            </div>
                        </template>
                    </BaseTooltip>
                </template>

                <template v-slot:[`item.regions`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:text>{{ getRegionsInclude(item.regions) }}</template>
                        <template v-slot:content>
                            <div class="ellipsis" :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-regions'">
                                {{ getRegionsInclude(item.regions) }}
                            </div>
                        </template>
                    </BaseTooltip>
                </template>

                <!-- MSP = VAP -->
                <template v-slot:[`item.msp`]="{ item }">
                    <i18n-n v-if="item.msp != null" 
                        :value=item.msp format="number" 
                        :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-manufacturer-sales-price'">
                    </i18n-n>
                </template>

                <!-- PPD = HAP -->
                <template v-slot:[`item.ppd`]="{ item }">
                    <i18n-n v-if="item.ppd != null" 
                        :value=item.ppd format="number"
                        :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-published-price-to-dealer'">
                    </i18n-n>
                </template>

                <!-- SRP = EVK -->
                <template v-slot:[`item.srp`]="{ item }">
                    <i18n-n v-if="item.srp != null" 
                        :value=item.srp format="number"
                        :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-suggested-retail-price'">
                    </i18n-n>
                </template>

                <!-- SPS = TAS -->
                <template v-slot:[`item.sps`]="{ item }">
                    <i18n-n v-if="item.sps != null" 
                        :value=item.sps format="number"
                        :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-salesprice-published-to-society'">
                    </i18n-n>
                </template>

                <!-- Price Category = budget | mid | high  -->
                <template v-slot:[`item.priceCategory`]="{ item }">
                     <div :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-price-category'">
                        {{ $t(getPriceCategory(item.priceCategory)) }}
                    </div>
                </template>

                <!-- Currency -->
                <template v-slot:[`item.currency`]="{ item }">
                     <div :alvqa="alvqaBaseString + 'read-only-row-' + item.id + '-currency'">{{ item.currency }}</div>
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import { DropdownGeneralPriceCategories } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PricelistsRowsReadOnlyPanel",
    components: {
        BasePanel,
        BaseTooltip
    },
    props:{
        pricelistsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqaBaseString: "erp-pricelists-list-row-" + this.pricelistsAlvId + "-"
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedPricelists.find(element => {                
                return element.alvId === this.pricelistsAlvId
            }) 
            return item
        },
        headers() {
            return [
                {   text: this.$t('lang_ERP_PRICELISTS_CAPTION_DISTRIBUTOR'), 
                    alvqa: this.alvqaBaseString + "header-distributor-name",
                    align: "left", 
                    sortable: false, 
                    value: "distributorName", 
                    tooltip:"", 
                    class: 'text-no-wrap'},

                {   text: this.$t('lang_ERP_PRICELISTS_CAPTION_REGION'), 
                    alvqa: this.alvqaBaseString + "header-region",
                    align: "left", 
                    sortable: false, 
                    value: "regions",
                    tooltip:"", 
                    width: "120px"},
                    
                {   text: this.$t('lang_GENERIC_LABEL_CAPTION_MSP'), 
                    alvqa: this.alvqaBaseString + "header-msp-manufacturer-sales-price",
                    align: "right", 
                    sortable: false, 
                    value: "msp", 
                    tooltip:"", 
                    width: "80px"},
                    
                {   text: this.$t('lang_GENERIC_LABEL_CAPTION_PPD'), 
                    alvqa: this.alvqaBaseString + "header-ppd-published-price-to-dealer",
                    align: "right", 
                    sortable: false, 
                    value: "ppd", 
                    tooltip:"", 
                    width: "80px"},

                {   text: this.$t('lang_GENERIC_LABEL_CAPTION_SRP'), 
                    alvqa: this.alvqaBaseString + "header-srp-suggested-retail-price",
                    align: "right", 
                    sortable: false, 
                    value: "srp", 
                    tooltip:"", 
                    width: "80px"},
                    
                {   text: this.$t('lang_GENERIC_LABEL_CAPTION_SPS'), 
                    alvqa: this.alvqaBaseString + "header-sps-salesprice-published-to-society",
                    align: "right", 
                    sortable: false, 
                    value: "sps", 
                    tooltip:"", 
                    width: "80px"},

                {   text: this.$t('lang_ERP_PRICELISTS_CAPTION_PRICE_CATEGORY'), 
                    alvqa: this.alvqaBaseString + "header-price-category",
                    align: "left", 
                    sortable: false, 
                    value: "priceCategory", 
                    tooltip:"", 
                    width: "120px"},

                {   text: this.$t('lang_ACCOUNT_COMPANIES_CAPTION_CURRENCY'), 
                    alvqa: this.alvqaBaseString + "header-currency",
                    align: "left", 
                    sortable: false, 
                    value: "currency", 
                    tooltip:"", 
                    width: "120px"},
                    
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getRegionsInclude(regions) {
            return regions.include.join('+')
        },
        getPriceCategory(selection, type = "text") {
            if (selection) {
                return DropdownGeneralPriceCategories.find(obj => {
                    return obj.value == selection
                })[type]
            }
            return ""
        },
    }    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>